<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-01-02 12:55:35
 * @FilePath: /smartEarthDemo/src/demo/scene/las.vue
 * @Description: 
-->
<template>
<div style="height:100%">
    <div id="cesiumContainer">
    </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {
          viewer:null
        }
    },
    mounted(){
        var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
       this.init()
    },
    methods: {
        init () {
            let viewer=util.getViewer('cesiumContainer',{
                // imageryProvider : new Cesium.UrlTemplateImageryProvider({
                //     // url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
                //     url: qexc.tiles.basic,
                //     layers: 'earth'
                // }),
              baseLayerPicker: false
            });

           let url="/demo/static/data/models/las/tileset.json";
            // let url = "http://localhost:9000/model/f9548700f62511e9a13ca36c98e3e393/tileset.json";
            let tileset = new Cesium.Cesium3DTileset({
                url: url
            });
            tileset.readyPromise.then(function(tileset) {
                viewer.scene.primitives.add(tileset);
                var cartographic = Cesium.Cartographic.fromCartesian(tileset.boundingSphere.center);
                var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
                var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, -25);
                var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
                // tileset.style = new Cesium.Cesium3DTileStyle({
                //     color : {
                //         conditions : [
                //             ['${Height} >= 100', 'color("purple", 0.5)'],
                //             ['${Height} >= 50', 'color("red")'],
                //             ['true', 'color("blue")']
                //         ]
                //     },
                //     show : '${Height} > 0',
                //     meta : {
                //         description : '"Building id ${id} has height ${Height}."'
                //     }
                // });
                viewer.zoomTo(tileset);
                 }).otherwise(function(error) {
                console.log(error);
            });


        }
    },
}
</script>
<style scoped>
#cesiumContainer{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
</style>
